import { render, staticRenderFns } from "./blank-page.vue?vue&type=template&id=18089f7f&"
import script from "./blank-page.vue?vue&type=script&lang=ts&"
export * from "./blank-page.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports